import { createContext } from 'react'
import { GetStationHeaderResponse } from '@loom-api-types'

export const StationContext = createContext<GetStationHeaderResponse | null>(null)
